
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.5 24a.5.5 0 01-.5-.5V.5a.5.5 0 011 0v23a.5.5 0 01-.5.5z"}}),_c('path',{attrs:{"d":"M23.5 24H.5a.5.5 0 010-1h23a.5.5 0 010 1zM2.55 19a.5.5 0 01-.36-.85l6.46-6.43a.5.5 0 01.48-.13l6.64 1.77 5.04-7.16-2.4.42a.5.5 0 01-.57-.4.51.51 0 010-.1.5.5 0 01.4-.48l3.6-.64a.47.47 0 01.34.06.44.44 0 01.08.06.49.49 0 01.15.25v.04l.64 3.56a.5.5 0 11-.99.17l-.42-2.38-5.24 7.46a.5.5 0 01-.54.19l-6.7-1.79-6.25 6.22a.5.5 0 01-.35.15z"}})])
          )
        }
      }
    